import { useClipboard } from '@dwarvesf/react-hooks';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { PlotRoutes } from 'Routes';
import { IconBoldArrowLeft1 } from 'components/icons/components/bold/IconBoldArrowLeft1';
import { IconBoldCloseSquare } from 'components/icons/components/bold/IconBoldCloseSquare';
import { IconLinearMaximize4 } from 'components/icons/components/linear/IconLinearMaximize4';
import { IconOutlineLink2 } from 'components/icons/components/outline/IconOutlineLink2';
import { Link } from 'react-router-dom';
import { theme } from 'styles/theme';
import { SocialMediaListeningPostDetailView } from './SocialMediaListeningPostDetailView';

type Props = {
  brandId: string;

  copyLink?: string;

  title?: string;
  isOpen: boolean;
  onClose: () => void;

  postId: string;
  topicIds?: string[];
  searchParams?: URLSearchParams;
};

export const SocialMediaListeningPostDetailDialogView = ({
  brandId,
  title,
  isOpen,
  onClose,
  postId,
  topicIds = [],
  searchParams,
  copyLink,
}: Props) => {
  const { onCopy: onCopyLink, hasCopied } = useClipboard(copyLink || '');

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',
          maxWidth: '1024px',
          borderRadius: theme.spacing(6),
          padding: theme.spacing(6),
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pb={4}
        mb={4}
        borderBottom={`1px solid ${theme.colors?.utility[275]}`}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton
            disableRipple
            onClick={onClose}
            sx={{ color: theme.colors?.primary.black, p: 0 }}
          >
            <IconBoldArrowLeft1 size={24} />
          </IconButton>
          {title && (
            <Typography
              variant="headline-sm"
              color={theme.colors?.primary.black}
            >
              {title}
            </Typography>
          )}
        </Box>

        <Box display="flex" gap={5} alignItems="center">
          {copyLink && (
            <Button
              variant="tertiary"
              startIcon={<IconOutlineLink2 size={16} />}
              onClick={onCopyLink}
              size="small"
              sx={{
                bgcolor: '#2306031A',
                borderRadius: 100,
              }}
            >
              {hasCopied ? 'Copied' : 'Copy link'}
            </Button>
          )}
          <Link to={PlotRoutes.socialListeningPost(postId, brandId)}>
            <IconButton
              disableRipple
              sx={{ color: theme.colors?.primary.black, p: 0 }}
            >
              <IconLinearMaximize4 size={18} />
            </IconButton>
          </Link>
          <IconButton
            disableRipple
            onClick={onClose}
            sx={{ color: theme.colors?.primary.black, p: 0 }}
          >
            <IconBoldCloseSquare size={24} />
          </IconButton>
        </Box>
      </Box>
      <SocialMediaListeningPostDetailView
        brandId={brandId}
        socialPostId={postId}
        searchParams={
          // social listening post detail dialog accepts searchCriteria as a query param to apply a filter on the detail page from the list page
          new URLSearchParams({
            ...Object.fromEntries(searchParams?.entries() ?? []),
            searchCriteria: window.btoa(
              JSON.stringify({ filters: { topicIds } }),
            ),
          })
        }
        componentProps={{
          modalView: true,
        }}
      />
    </Dialog>
  );
};
